"use client"

import React from "react"
import styled, { css } from "styled-components"
import {
  h1Styles,
  h2Styles,
  h3Styles,
  pStyles,
} from "@jobintrans/base-ui.components.atoms.typography"
import { StyledType } from "@jobintrans/base-ui.types.base-styles"

export const textHTMLStyles = css<{
  $type?: string
}>`
  * {
    overflow-wrap: break-word;
  }

  ul,
  ol {
    li {
      font-size: ${({ theme }) => theme.font.L};
    }
  }

  h1 {
    ${h1Styles};
    margin-top: ${({ theme }) => theme.space.L};
  }

  h2 {
    ${h2Styles};
    margin-top: ${({ theme }) => theme.space.M};
  }

  h3 {
    ${h3Styles};
    margin-top: ${({ theme }) => theme.space.S};
  }

  p {
    ${pStyles};
  }

  table {
    margin: ${({ theme }) => theme.space.S} 0;

    th,
    td {
      padding: 5px 10px;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  ${({ $type }) =>
    $type === "secondary" &&
    css`
      ul,
      ol {
        li {
          font-size: ${({ theme }) => theme.font.M};
        }
      }

      h1 {
        font-size: ${({ theme }) => theme.font.XL};
        margin-top: ${({ theme }) => theme.space.M};
        margin-bottom: ${({ theme }) => theme.space.M};
      }

      h2 {
        font-size: ${({ theme }) => theme.font.L};
        margin-top: ${({ theme }) => theme.space.S};
        margin-bottom: ${({ theme }) => theme.space.S};
      }

      h3 {
        font-size: ${({ theme }) => theme.font.M};
        margin-top: ${({ theme }) => theme.space.XS};
        margin-bottom: ${({ theme }) => theme.space.XS};
      }

      p {
        font-size: ${({ theme }) => theme.font.M};
      }
    `}

  ${({ $type }) =>
    $type === "third" &&
    css`
      ul,
      ol {
        li {
          font-size: ${({ theme }) => theme.font.S};
        }
      }

      h1 {
        font-size: ${({ theme }) => theme.font.L};
        margin-top: ${({ theme }) => theme.space.S};
        margin-bottom: ${({ theme }) => theme.space.S};
      }

      h2 {
        font-size: ${({ theme }) => theme.font.M};
        margin-top: ${({ theme }) => theme.space.XS};
        margin-bottom: ${({ theme }) => theme.space.XS};
      }

      h3 {
        font-size: ${({ theme }) => theme.font.S};
        margin-top: ${({ theme }) => theme.space.XXS};
        margin-bottom: ${({ theme }) => theme.space.XXS};
      }

      p {
        font-size: ${({ theme }) => theme.font.S};
      }
    `}
`

function TextHTML({ $type = "primary", content }: { $type?: StyledType; content: string }) {
  return <Wrapper $type={$type} dangerouslySetInnerHTML={{ __html: content }} />
}

export default TextHTML

const Wrapper = styled.div<{
  $type?: string
}>`
  ${textHTMLStyles};
`
